import { render } from "./ChangeTheme.vue?vue&type=template&id=0ec61e00&scoped=true"
import script from "./ChangeTheme.vue?vue&type=script&lang=js"
export * from "./ChangeTheme.vue?vue&type=script&lang=js"

import "./ChangeTheme.vue?vue&type=style&index=0&id=0ec61e00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec61e00"]])

export default __exports__